/*
 * Get-staff.ts
 * Description: Includes the declaration
 * of the function for getting staff members
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store
import {store} from '@/config/plugins';

/**
 * Getting list of staff members
 *
 * @return {Object} Promise - a list of staff members
 * @param {String} slug - id of the restaurant
 */
export function getStaff(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/users',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
                query: store.getters.queryParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
